<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
    <div class="content">
    <div class="content-title">
      <h2>
        プレミアムふきだしコメント
      </h2>
      <p>フォントや色をカスタマイズできます</p>
    </div>
    <div class="contents-block">
        <div class="line__left" v-bind:class="fontStyle" v-bind:style="[mainColor, subColor, svgBackground]">
            <div class="line__left-text">
                <div class="text">Hello🐟</div>
            </div>
            <div class="line__left-text">
                <div class="text">いい天気ですね</div>
            </div>
        </div>
        <div class="set">
        <h3>フォント選択</h3>
        <div class="font-dropdown-container">
          <div class="custom-font-dropdown" :class="{ open: fontDropdownOpen }">
            <div class="dropdown-selected" @click="toggleFontDropdown">
              <span :class="getCurrentFontClass()" class="selected-font-preview">{{ getCurrentFontName() }}</span>
              <span class="dropdown-arrow">▼</span>
            </div>
            <div class="dropdown-options" v-if="fontDropdownOpen">
              <div v-for="category in fontCategories" :key="category.label" class="font-category">
                <div class="category-label">{{ category.label }}</div>
                <div v-for="font in category.fonts" :key="font.value" 
                     class="dropdown-option" :class="font.class"
                     @click="selectFont(font.value)">
                  <span class="font-preview-text">{{ getFontPreviewText(category.label) }}</span>
                  <span class="font-name-small">{{ font.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3>カラー選択</h3>
        <div class="color-picker-grid">
          <div class="color-picker-column">
            <h4>フォントカラー</h4>
            <div class="color-picker-wrapper">
              <chrome-picker :value="colors" v-model="colors"></chrome-picker>
            </div>
          </div>
          <div class="color-picker-column">
            <h4>背景カラー</h4>
            <div class="color-picker-wrapper">
              <chrome-picker :value="colors3" v-model="colors3"></chrome-picker>
            </div>
          </div>
          <div class="color-picker-column">
            <h4>サブカラー</h4>
            <div class="color-picker-wrapper">
              <chrome-picker :value="colors2" v-model="colors2"></chrome-picker>
            </div>
          </div>
        </div>

        <h3>コピペ用CSS</h3>
        <div class="url-description">
          <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
        </div>
        <div class="url-container">
          <textarea id="target" readonly class="url-input textarea" v-model="resultCSS" />
          <button @click="copy" class="url-copy-btn">
            <span>コピー</span>
          </button>
        </div>
        </div>
    </div>
    </div>
</div>
  </div>
</template>
<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
import { Chrome } from "vue-color";
export default {
  name: "app",
  components: {
    secondHeader,
    sidebar,
    "chrome-picker": Chrome,
  },

  data() {
    return {
        fontstyle:'font1',
        colors: {
            hex: "#571512",
            hex8: '#571512',
            hsl: { h: 3, s: 79, l: 34, a: 1 },
            rgba: { r: 87, g: 21, b: 18, a: 1 },
            a: 1,
        },
        colors2: {
            hex: "#f0c8a4",
            hex8: '#f0c8a4',
            hsl: { h: 28, s: 32, l: 94, a: 1 },
            rgba: { r: 240, g: 200, b: 164, a: 1 },
            a: 1,
        },
        colors3: {
            hex: "#ffffff",
            hex8: '#ffffff',
            hsl: { h: 28, s: 0, l: 100, a: 1 },
            rgba: { r: 255, g: 255, b: 255, a: 1 },
            a: 1,
        },
        svgBackground: {
          "--bg-svg": '',
          "--bg-color": ''
        },
        importcss1:':root{--main-color:',
        importcss2: "!important;--sub-color:",
        importcss3: "!important;--bg-color:",
        importcss4: "!important;--bg-svg:",
        fontcss:'!important;\n--font: "Zen Kaku Gothic Antique", sans-serif!important;}',
        fontDropdownOpen: false,
        fontCategories: [
          {
            label: 'ゴシック',
            fonts: [
              { value: 'font1', name: 'Zen角ゴシックAntique', class: 'font1' },
              { value: 'font4', name: 'DotGothic16', class: 'font4' },
              { value: 'font7', name: 'M PLUS Rounded 1c', class: 'font7' },
              { value: 'font6', name: 'キウイ丸', class: 'font6' }
            ]
          },
          {
            label: 'ポップ',
            fonts: [
              { value: 'font2', name: 'はちまるポップ', class: 'font2' },
              { value: 'font8', name: 'ロックンロールOne', class: 'font8' }
            ]
          },
          {
            label: '明朝',
            fonts: [
              { value: 'font12', name: 'さわらび明朝', class: 'font12' },
              { value: 'font13', name: 'しっぽり明朝', class: 'font13' }
            ]
          },
          {
            label: 'デザイン',
            fonts: [
              { value: 'font3', name: 'Stick', class: 'font3' },
              { value: 'font5', name: '解星デコール', class: 'font5' },
              { value: 'font9', name: '佑字【舞】', class: 'font9' },
              { value: 'font10', name: '油性マジック', class: 'font10' }
            ]
          },
          {
            label: 'Chinese',
            fonts: [
              { value: 'font14', name: 'Noto Serif', class: 'font14' }
            ]
          },
          {
            label: 'English',
            fonts: [
              { value: 'font15', name: 'Josefin Sans', class: 'font15' }
            ]
          }
        ],
    };
  },
  watch: {
    colors3: {
      handler() {
        this.updateSvgBackground();
      },
      deep: true
    },
    fontstyle:function(){
        this.setFontCss()
    },
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.importcss1 +
            this.colors.hex8 +
            this.importcss2 +
            this.colors2.hex8 +
            this.importcss3 +
            this.colors3.hex8 +
            this.importcss4 +
            this.svgBackground["--bg-svg"] +
            this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },

    setFontCss: function(){
        switch(this.fontstyle){
            case 'font1':
                this.fontcss = '!important;\n--font: "Zen Kaku Gothic Antique", sans-serif;}'
                break;
            case 'font2':
                this.fontcss = '!important;\n--font: "Hachi Maru Pop", cursive;}'
                break;
            case 'font3':
                this.fontcss = '!important;\n--font: "Stick", sans-serif;}'
                break;
            case 'font4':
                this.fontcss = '!important;\n--font: "DotGothic16", sans-serif;}'
                break;
            case 'font5':
                this.fontcss = '!important;\n--font: "Kaisei Decol", serif;}'
                break;
            case 'font6':
                this.fontcss = '!important;\n--font: "Kiwi Maru", serif;}'
                break;
            case 'font7':
                this.fontcss = '!important;\n--font: "M PLUS Rounded 1c", sans-serif;}'
                break;
            case 'font8':
                this.fontcss = '!important;\n--font: "RocknRoll One", sans-serif;}'
                break;
            case 'font9':
                this.fontcss = '!important;\n--font: "Yuji Mai", serif;}'
                break;
            case 'font10':
                this.fontcss = '!important;\n--font: "Yusei Magic", sans-serif;}'
                break;
            case 'font12':
                this.fontcss = '!important;\n--font:  "Sawarabi Mincho", serif;";}'
                break;
            case 'font13':
                this.fontcss = '!important;\n--font: "Shippori Mincho", serif;}'
                break;
            case 'font14':
                this.fontcss = '!important;\n--font: "Noto Serif SC", serif;}'
                break;
            case 'font15':
                this.fontcss = '!important;\n--font: "Josefin Sans", sans-serif;}'
                break;
        }
    },
    updateSvgBackground() {
      const svgcolor = this.colors3.hex.replace('#', '%23');
      const bgcolor = this.colors3.hex8;
      this.svgBackground = {
        "--bg-svg": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 256 256'%3E%3Cpath fill='${svgcolor}' d=' M 14.91 25.23 C 84.03 40.91 154.80 53.31 225.11 54.26 A 0.37 0.37 -89.9 0 1 225.48 54.63 L 225.67 242.23 A 0.31 0.31 -75.9 0 1 225.22 242.50 Q 210.97 235.22 197.62 226.40 Q 137.70 186.80 90.16 129.07 Q 49.24 79.39 14.56 25.73 Q 14.13 25.05 14.91 25.23 Z'%0A/%3E%3C/svg%3E")`,
        "--bg-color": `${bgcolor}`
      };
    },
    toggleFontDropdown() {
      this.fontDropdownOpen = !this.fontDropdownOpen;
    },
    selectFont(fontValue) {
      this.fontstyle = fontValue;
      this.fontDropdownOpen = false;
    },
    getCurrentFontName() {
      for (const category of this.fontCategories) {
        const font = category.fonts.find(f => f.value === this.fontstyle);
        if (font) return font.name;
      }
      return 'Zen角ゴシックAntique';
    },
    getCurrentFontClass() {
      for (const category of this.fontCategories) {
        const font = category.fonts.find(f => f.value === this.fontstyle);
        if (font) return font.class;
      }
      return 'font1';
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.custom-font-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.fontDropdownOpen = false;
      }
    },
    getFontPreviewText(categoryLabel) {
      switch(categoryLabel) {
        case 'Chinese':
          return '你好世界';
        case 'English':
          return 'Hello World';
        default:
          return 'いい天気ですね';
      }
    }
  },
  computed: {
    resultCSS(){
        return this.importcss1 +
            this.colors.hex8 +
            this.importcss2 +
            this.colors2.hex8 +
            this.importcss3 +
            this.colors3.hex8 +
            this.importcss4 +
            this.svgBackground["--bg-svg"] +
            this.fontcss;
    },
    mainColor() {
      return {
        "--main-color": this.colors.hex8,
      };
    },
    subColor() {
      return {
        "--sub-color": this.colors2.hex8,
      };
    },
    fontStyle: function() {
      if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5';
      }
      else if (this.fontstyle === 'font6') {
        return 'font6';
      }
      else if (this.fontstyle === 'font7') {
        return 'font7';
      }
      else if (this.fontstyle === 'font8') {
        return 'font8';
      }
      else if (this.fontstyle === 'font9') {
        return 'font9';
      }
      else if (this.fontstyle === 'font10') {
        return 'font10';
      }
      else if (this.fontstyle === 'font12') {
        return 'font12';
      }
      else if (this.fontstyle === 'font13') {
        return 'font13';
      }
      else if (this.fontstyle === 'font14') {
        return 'font14';
      }
      else if (this.fontstyle === 'font15') {
        return 'font15';
      }
      else {
        return '';
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  created() {
    this.updateSvgBackground();
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Stick&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');

@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Kaisei+Decol:wght@500&family=Kiwi+Maru:wght@500&family=M+PLUS+Rounded+1c:wght@500&family=RocknRoll+One&family=Sawarabi+Mincho&family=Shippori+Mincho:wght@500&family=Yuji+Mai&family=Yusei+Magic&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&family=Noto+Serif+SC&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}


.contents-block{

	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;

}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
  }
}
.set{
  padding: 8px 12px 24px 12px;

  border-radius: 10px;
  margin-left:12px;
}

/* コメントエリア */
.preview{
    padding: 2px 12px;
}
.line__left{
    background-color: #F2F0E9;
    padding:12px 0;
}
.line__left-text{
    margin: 6px auto !important;
    overflow: hidden !important;
    font-weight: bold !important;
    font-size: 16px !important;
    background-color: rgba(0, 0, 0, 0) !important;
    line-height: 1.8;
    letter-spacing: 0.1em;
    padding:12px 32px;
}

.text {
    display: inline-block !important;
    width: auto !important;
    color: var(--main-color);
  margin-left: 28px;
  padding: 10px 22px;
  position: relative;
  border-radius: 20px;
  box-shadow: 3px 3px 0 var(--sub-color);
  /* background-color: #ffffff; */
  background-color: var(--bg-color);
}

/* 吹き出し */
.text:after {
    content: '';
    position: absolute;
    left: -8px;
    top: 7px;
    width: 1em;
    height: 1em;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 256 256'%3E%3Cpath fill='%23ffffff' d=' M 14.91 25.23 C 84.03 40.91 154.80 53.31 225.11 54.26 A 0.37 0.37 -89.9 0 1 225.48 54.63 L 225.67 242.23 A 0.31 0.31 -75.9 0 1 225.22 242.50 Q 210.97 235.22 197.62 226.40 Q 137.70 186.80 90.16 129.07 Q 49.24 79.39 14.56 25.73 Q 14.13 25.05 14.91 25.23 Z'%0A/%3E%3C/svg%3E"); */
    background-image: var(--bg-svg);

}


.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.font1{
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.font2{
    font-family: 'Hachi Maru Pop', cursive;
}
.font3{
    font-family: 'Stick', sans-serif;
}
.font4{
    font-family: "DotGothic16", sans-serif;
}
.font5{
    font-family: "Kaisei Decol", serif;
}
.font6{
    font-family: "Kiwi Maru", serif;
}
.font7{
    font-family: "M PLUS Rounded 1c", sans-serif;
}
.font8{
    font-family: "RocknRoll One", sans-serif;
}
.font9{
    font-family: "Yuji Mai", serif;
}
.font10{
    font-family: "Yusei Magic", sans-serif;
}
.font12{
    font-family: 'Sawarabi Mincho', serif;
}
.font13{
    font-family: 'Shippori Mincho', serif;
}
.font14{
    font-family: 'Noto Serif SC', serif;
}
.font15{
    font-family: 'Josefin Sans', sans-serif;
}
.radio-main{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

/* Custom Font Dropdown with Categories */
.font-dropdown-container {
  margin-top: 12px;
  position: relative;
}

.custom-font-dropdown {
  position: relative;
  width: 100%;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-selected:hover {
  box-shadow: 0 0 0 1px #999 inset;
}

.custom-font-dropdown.open .dropdown-selected {
  box-shadow: 0 0 0 2px #0f172a;
}

.selected-font-preview {
  flex: 1;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}

.custom-font-dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #ccc;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 2px;
}

.font-category {
  border-bottom: 1px solid #f0f0f0;
}

.font-category:last-child {
  border-bottom: none;
}

.category-label {
  padding: 8px 16px 4px 16px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #f9fafb;
  border-bottom: 1px solid #f0f0f0;
}

.dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #f8f8f8;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  background-color: #f8f8f8;
}

.font-preview-text {
  font-size: 14px;
  margin-bottom: 6px;
  letter-spacing: 0.05em;
}

.font-name-small {
  font-size: 11px;
  color: #666;
  font-family: system-ui, -apple-system, sans-serif;
}

/* Color Picker Grid Layout */
.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 12px;
}

.color-picker-column {
  min-width: 0;
}

.color-picker-column h4 {
  font-size: 12px;
  margin: 0 0 8px 0;
  color: #4a5568;
  font-weight: 600;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 0;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

.color-picker-wrapper .vc-hue-pointer,
.color-picker-wrapper .vc-alpha-pointer {
  width: 16px;
  height: 16px;
}

.color-picker-wrapper .vc-hue-picker,
.color-picker-wrapper .vc-alpha-picker {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-wrapper .vc-saturation-pointer {
  width: 14px;
  height: 14px;
}

.color-picker-wrapper .vc-saturation-circle {
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 76px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}

@media screen and (max-width: 1024px) {
  .color-picker-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .color-picker-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

.line__left{
  display: block;
  white-space: nowrap;

}
</style>